import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { success, error } from '../utils/alert';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '', rememberMe: false });
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password, form.rememberMe);
      success('ເຂົ້າສູ່ລະບົບສຳເລັດ!');
      navigate('/');
    } catch (err) {
      error('ເຂົ້າສູ່ລະບົບບໍ່ສຳເລັດ!');
      error(err.response?.data?.message || 'ເກີດຂໍ້ຜິດພາດ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center animate-fade-in">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-dark rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg animate-float">
            <span className="text-3xl">₿</span>
          </div>
          <h1 className="text-xl font-bold text-dark">DebtBook</h1>
          <p className="text-muted text-sm mt-1">ລະບົບຈັດການໜີ້</p>
        </div>

        {/* Form */}
        <div className="card shadow-md">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">ຊື່ຜູ້ໃຊ້</label>
              <input
                type="text"
                placeholder="username"
                value={form.username}
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                className="input-field"
                autoComplete="username"
                required
              />
            </div>
            <div>
              <label className="label">ລະຫັດຜ່ານ</label>
              <div className="relative">
                <input
                  type={show ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={form.password}
                  onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                  className="input-field pr-10"
                  autoComplete="current-password"
                  required
                />
                <button type="button" onClick={() => setShow(!show)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted text-sm">
                  {show ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            {/* Remember me */}
            <label className="flex items-center gap-2.5 cursor-pointer">
              <div
                onClick={() => setForm(f => ({ ...f, rememberMe: !f.rememberMe }))}
                className={`w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all
                  ${form.rememberMe ? 'bg-dark border-dark' : 'border-muted/50'}`}>
                {form.rememberMe && <span className="text-cream text-xs">✓</span>}
              </div>
              <span className="text-sm text-dark">ຈື່ຈຳຂ້ອຍ 15 ວັນ</span>
            </label>

            <button type="submit" disabled={loading}
              className="w-full btn-primary py-3 text-base flex items-center justify-center gap-2">
              {loading ? <div className="w-5 h-5 border-2 border-cream border-t-transparent rounded-full animate-spin" /> : 'ເຂົ້າສູ່ລະບົບ'}
            </button>
          </form>
        </div>

        <div className="text-center mt-4">
          <Link to="/" className="text-muted text-xs">← ກັບໜ້າຫຼັກ</Link>
        </div>
      </div>
    </div>
  );
}
